<script lang="ts">
  import { onMount } from "svelte";
  import { Capacitor } from "@capacitor/core";
  import { location, push } from "svelte-spa-router";
  import { entities, isClient, translate } from "lib";
  import { user } from "stores";
  import { unreadAiActions } from "../stores/notificationStore";

  interface Tab {
    title: string;
    route: string;
  }

  export let entity: string;

  let selected = $location;
  let tabs: Array<Tab> = [];
  onMount(async () => {
    if (entity === entities.PROGRESS) {
      tabs = [];
      tabs.push({ title: "HABITS", route: "/progress/habits" });
      tabs.push({ title: "MEASUREMENTS", route: "/progress/measurements" });
      tabs.push({ title: "GOALS", route: "/progress/goals" });
      tabs.push({ title: "GALLERY", route: "/progress/gallery" });
    } else if (entity === entities.DIET && !isClient($user)) {
      tabs = [];
      tabs.push({ title: "MEAL_PLANS", route: "/diet/meal-plans" });
      tabs.push({ title: "RECIPES", route: "/diet/recipes" });
      tabs.push({ title: "INGREDIENTS", route: "/diet/ingredients" });
    } else if (entity === entities.DIET && isClient($user)) {
      tabs = [];
      tabs.push({ title: "MEAL_PLAN", route: "/diet/meal-plan" });
      tabs.push({ title: "DIET_JOURNAL", route: "/diet/journal" });
      tabs.push({ title: "IF_TRACKING", route: "/diet/fasting" });
    } else if (entity === entities.TRAINING && !isClient($user)) {
      tabs = [];
      tabs.push({ title: "PROGRAMS", route: "/training/programs" });
      tabs.push({ title: "WORKOUTS", route: "/training/workouts" });
      tabs.push({ title: "EXERCISES", route: "/training/exercises" });
    } else if (entity === entities.TRAINING && isClient($user)) {
      tabs = [];
      tabs.push({ title: "TRAINING_PLAN", route: "/training/program" });
      tabs.push({ title: "TRAINING_JOURNAL", route: "/training/journal" });
    } else if (entity === entities.CLIENTS) {
      tabs = [];
      tabs.push({ title: "CLIENTS", route: "/clients/list" });
      tabs.push({ title: "PAYMENTS", route: "/clients/payments" });
      tabs.push({ title: "GROUPS", route: "/clients/groups" });
      tabs.push({ title: "TRAINERS", route: "/clients/trainers" });
    } else if (entity === entities.NOTIFICATIONS) {
      tabs = [];
      tabs.push({ title: "EXPIRY_VIEW", route: "/notifications/expiry" });
      tabs.push({ title: "REMINDERS", route: "/notifications/reminders" });
      tabs.push({ title: "NOTIFICATIONS", route: "/notifications" });
      tabs.push({ title: "AI", route: "/notifications/ai" });
    }

  });
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="menu flex-row center-space-around bg-white dark:bg-zinc-800 border-b border-slate-300 dark:border-zinc-700"
>
  {#each tabs as tab}
    <div
      class="tab-item {selected === tab.route
        ? 'text-primary-500 font-bold'
        : 'text-slate-900 dark:text-slate-100'}"
      on:click={async () => await push(tab.route)}
    >
      {translate(tab.title)}
      {#if tab.route === "/notifications/ai" && $unreadAiActions > 0}
        <span class="ai-tab-bubble">{$unreadAiActions}</span>
      {/if}
    </div>
  {/each}
</div>
{#if Capacitor.isNativePlatform()}
  <div class="mb-6" />
{/if}

<style>
  .menu {
    position: sticky;
    top: 0;
    max-width: 720px;
    left: 0;
    right: 0;
    margin: auto;
    height: 48px;
    width: 100%;
    z-index: 2;
    padding-top: calc((var(--safe-area-inset-top, env(safe-area-inset-top)) * 1.25) + var(--app-top-extra));
    padding-bottom: calc((var(--safe-area-inset-top, env(safe-area-inset-top)) / 2) + var(--app-tab-bottom-extra));
  }
  .tab-item {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
  /* Purple to match the AI dot on the bell icon in the bottom menu —
     same signal, same color. Inline pill rather than absolute so it
     can't overlap adjacent tab labels on narrower screens. */
  .ai-tab-bubble {
    margin-left: 6px;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background-color: #9333ea; /* tailwind purple-600 */
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
  }
</style>
